export * from "@workspace/gamja-platform/components/ui/table";
